import { post, get, internalGet } from '.';
import qs from 'qs';

export const sendRequestAccess = () => post(`/dmc-request-access`);
export const getDmcRequestAccess = () => get(`/dmc-request-access`);
export const getAllDmcRequestAccess = ({ filters, skip }) => {
  if (skip) {
    return Promise.resolve(null);
  }
  return internalGet(`/dmc-request-access/all?${qs.stringify(filters)}`);
};
